export enum RepositoryTabs {
  DATA = 'Data',
  COLLABORATORS = 'Collaborators',
}
